<div class="import-header-button-container flex align-center">
    <import-button [table]="table" [tableType]="tableType"></import-button>
    <app-create-use-button [table]="table" [zoningCodeId]="zoningCodeId"></app-create-use-button>
</div>

<div *ngIf="zoningCode">
    <data-table [table]="table" [zoningCodeId]="zoningCodeId" [tableType]="tableType"></data-table>
</div>

<div *ngIf="table">
    <mat-toolbar>
        <div class="import-button">
            <button (click)="importData()" [disabled]="!canImport" class="button action">Import</button>
        </div>
    </mat-toolbar>
</div>
